import * as types from '../actionTypes';
import * as eventTypes from '../eventTypes';
import initialState from 'reducers/initialState';

export const facilitySublimitsReducer = (state = initialState.facilities.facilitySublimits, action) => {
  switch (action.type) {
    case types.LOAD_FACILITY_SUBLIMITS_STARTED: {
      const { key } = action;
      let result = { ...state };
      result[key] = { ...state[key], loading: true, loaded: false };

      return result;
    }

    case types.LOAD_FACILITY_SUBLIMITS_SUCCEEDED: {
      const { key } = action;
      let result = { ...state };
      result[key] = { ...state[key], loading: false, loaded: true, ids: action.result };

      return result;
    }

    case types.LOAD_FACILITY_SUBLIMITS_FAILED: {
      const { key } = action;
      let result = { ...state };
      result[key] = { ...state[key], loading: false, loaded: false };

      return result;
    }

    case eventTypes.FACILITY_SUBLIMIT_SAVED: {
      const { sublimitId, documentId } = action.event.eventBody;
      let result = { ...state };
      let sublimitIdList = state[documentId].ids ? [...state[documentId].ids] : [];

      if (sublimitIdList.includes(sublimitId)) return result;
      else {
        sublimitIdList.push(sublimitId);
        result[documentId] = { ...result[documentId], ids: sublimitIdList };
        return result;
      }
    }

    case eventTypes.FACILITY_SUBLIMIT_DELETED: {
      const { sublimitId, documentId } = action.event.eventBody;
      let filterIdList = [...state[documentId].ids];
      filterIdList.splice(filterIdList.indexOf(sublimitId), 1);

      return {
        ...state,
        [documentId]: {
          ...state[documentId],
          ids: filterIdList
        }
      };
    }

    default:
      return state;
  }
};

export const facilitySublimitFiltersReducer = (state = initialState.facilities.facilitySublimitFilters, action) => {
  switch (action.type) {
    case types.LOAD_FACILITY_SUBLIMIT_FILTERS_STARTED: {
      const { key } = action;
      let result = { ...state };
      result[key] = { ...state[key], loading: true, loaded: false };

      return result;
    }

    case types.LOAD_FACILITY_SUBLIMIT_FILTERS_SUCCEEDED: {
      const { key } = action;
      let result = { ...state };
      result[key] = { ...state[key], loading: false, loaded: true, ids: action.result };

      return result;
    }

    case types.LOAD_FACILITY_SUBLIMIT_FILTERS_FAILED: {
      const { key } = action;
      let result = { ...state };
      result[key] = { ...state[key], loading: false, loaded: false };

      return result;
    }

    case types.UPDATE_FACILITY_SUBLIMIT_FILTERS_SUCCEEDED: {
      const { sublimitId, filters } = action;

      return {
        ...state,
        [sublimitId]: {
          ...state[sublimitId],
          ids: filters.map(filter => filter.filterId)
        }
      };
    }

    default:
      return state;
  }
};

export const facilitySublimitFinancingStructureFiltersReducer = (
  state = initialState.facilities.facilitySublimitFinancingStructureFilters,
  action
) => {
  switch (action.type) {
    case types.LOAD_FACILITY_SUBLIMIT_FINANCING_STRUCTURE_FILTERS_STARTED: {
      const { key } = action;
      let result = { ...state };
      result[key] = { ...state[key], loading: true, loaded: false };

      return result;
    }

    case types.LOAD_FACILITY_SUBLIMIT_FINANCING_STRUCTURE_FILTERS_SUCCEEDED: {
      const { key } = action;
      let result = { ...state };
      result[key] = { ...state[key], loading: false, loaded: true, ids: action.result };

      return result;
    }

    case types.LOAD_FACILITY_SUBLIMIT_FINANCING_STRUCTURE_FILTERS_FAILED: {
      const { key } = action;
      let result = { ...state };
      result[key] = { ...state[key], loading: false, loaded: false };

      return result;
    }

    case types.UPDATE_FACILITY_SUBLIMIT_FINANCING_STRUCTURE_FILTERS_SUCCEEDED: {
      const { sublimitId, filters } = action;

      return {
        ...state,
        [sublimitId]: {
          ...state[sublimitId],
          ids: filters.map(filter => filter.filterId)
        }
      };
    }

    default:
      return state;
  }
};
